import { useLatestCallback } from 'hook/useLatestCallback'
import { ChangeEvent, useLayoutEffect, useRef, useState } from 'react'
import { controller } from 'store/controller'
import { store } from 'store/store'
import { Photo } from 'type/Options'

export type QrUploadState = 'start' | 'processing' | 'success' | 'error'

// Общая логика страниц загрузки фото с телефона по QR: и для селфи, и для фото в полный рост.
export function useQrUpload(photo: Photo) {
  const input = useRef<HTMLInputElement>(null)
  const version = useRef(1)
  const [state, setState] = useState<QrUploadState>('start')

  useLayoutEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const identity_id = params.get('identity')
    const profile = identity_id ? store.identities.profiles.find(it => it.identity_id === identity_id) : undefined
    store.identities.selectProfile(profile)
    store.profile.type = photo
  }, [photo])

  const reset = useLatestCallback(() => {
    ++version.current
    setState('start')
  })

  const onClose = useLatestCallback(() => {
    window.close()
  })

  const onHelp = useLatestCallback(() => {
    store.profile.step = 'help'
  })

  const onFile = useLatestCallback(async (file: File) => {
    const { selfies, userPhoto, num } = store.profile.common
    const v = version.current
    selfies.forEach((it) => {
      if (it.origin === 'asset') it.clear()
    })
    try {
      setState('processing')

      if (photo === 'full') await userPhoto.setFile(file, 'qr')
      else await selfies[num].setFile(file, 'qr')

      await controller.saveProfileOnly()
      if (v !== version.current) return
      setState('success')
    } catch (e) {
      if (v !== version.current) return
      console.error('upload failed', e)
      setState('error')
    }
  })

  const onCamera = useLatestCallback(() => {
    input.current?.click()
  })

  const onCameraFile = useLatestCallback(async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) void onFile(file)
    if (input.current) input.current.value = ''
  })

  return { state, input, reset, onClose, onHelp, onFile, onCamera, onCameraFile }
}
